import { skipTracingStore } from "../store";

export const updateValidationError = (errorMessage: string) => {
  skipTracingStore.validationError = errorMessage;
};
